import React, { useState } from "react";
import { Row, Card } from 'antd'; 
import { compose, graphql, ApolloConsumer } from 'react-apollo';
import { addVoucherM, updateVoucherM } from '../../../graphql/mutation/voucher';
import AntSpin from "../../common/AntSpin";
import SelectClient from "../../common/selects/Clients";
import SelectRoom from "../../common/selects/Rooms";
import { handleInput } from "./handleInput";
import { validForm } from "../../../functions/validForm";
import { openNotificationWithIcon } from "../../common/Notification";
import SideButton from "../../common/SideButton";
import RangeDatePicker from "../../common/RangeDatePicker";

function VouchersForm({props, addVoucher, updateVoucher}){
    let [ voucher, setVoucher ] = useState({
        _id: "",
        beginDate: null,
        endDate: null,
        room: undefined,
        client: undefined
    });
    let [ loading, setLoading ] = useState(false);

    function update(){
        let body = {
            voucher,
            updateVoucher
        };

        props.UPDATE_VOUCHER(body);
        openNotificationWithIcon('success', "Sucesso", "Voucher atualizado com sucesso", "", 7);
        
        setVoucher(voucher = {...voucher,
            _id: "",
            beginDate: undefined,
            endDate: undefined,
            room: undefined,
            client: undefined
        })
    }

    function add(){
        let body = {
            voucher,
            addVoucher
        };  
        
        props.ADD_VOUCHER(body);
        openNotificationWithIcon('success', "Sucesso", "Voucher adicionado com sucesso", "", 7);

        setVoucher(voucher = {...voucher,
            _id: "",
            beginDate: undefined,
            endDate: undefined,
            room: undefined,
            client: undefined
        })
    }

    async function getVoucher(connection){
        if(localStorage.getItem('@Ossel:UpdateID')){
            setLoading(loading = true);

            const { data } = await connection.query({
                query: getVoucher,
                variables: { _id: localStorage.getItem('@Ossel:UpdateID') }
            }); 
          
            setVoucher(voucher = {...voucher,
                _id: data.voucher._id,
                beginDate: data.voucher.beginDate,
                endDate: data.voucher.endDate,
                room: data.voucher.room,
                client: data.voucher.client
            });
          
            localStorage.removeItem('@Ossel:UpdateID');
            setLoading(loading = false);
        }

        return null
    }

    function handleOk(){
        if(!validForm(voucher)){
            openNotificationWithIcon('warning', "Aviso", "Há informações incompletas no formulario.", "", 5);
            return 
        }
        
        if(voucher._id === "") add()
        else update()   
    }

    console.log(voucher)

    function renderBody(connection){
        getVoucher(connection);

        if(!loading) return(
            <Row>
                <Card
                    title="Cadastro"
                    style={{ width: "95%", marginTop: 25, marginLeft: "auto", marginRight: "auto" }}
                >
                    <RangeDatePicker
                        voucher={voucher} 
                        setVoucher={setVoucher}
                    />

                    <SelectClient
                        data={voucher} 
                        setData={setVoucher} 
                        handleInput={handleInput} 
                        profile={props.user.profile_info}
                    />

                    <SelectRoom
                        data={voucher} 
                        setData={setVoucher} 
                        handleInput={handleInput} 
                    />

                    <SideButton
                        clickAction={handleOk}
                    />
                </Card>
            </Row>
        )
        else return <AntSpin marginTop={"20%"}/>
    }

    return (
        <ApolloConsumer>
            {client => renderBody(client)}
        </ApolloConsumer>
    );
}

export default compose(
    graphql( addVoucherM, { name: "addVoucher" } ),
    graphql( updateVoucherM, { name: "updateVoucher" } ),
)(VouchersForm); 


// WEBPACK FOOTER //
// ./src/components/general/vouchersFormWrapper/VouchersForm.jsx